/**
 * Convert LogIndex to number
 *
 * @param {import('./LogIndexType.js').LogIndexType} index
 * @returns {number}
 */
export function toNumber(index) {
	return index;
}
